import React, { useContext } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const Genders = {
  Female: _TL_('Female'),
  Male: _TL_('Male'),
  Unknown: _TL_('Unknown'),
};

const sortGenders = genders => _.sortBy(genders, gender => Genders[gender]);

export const formatGender = (gender, i18n) => (Genders[gender] ? i18n.getString(Genders[gender]) : gender);

export const formatGenders = (genders, i18n) => _.chain(sortGenders(genders))
  .map(gender => formatGender(gender, i18n))
  .join(i18n.getString(_TL_(', ')))
  .value();

export const GenderTargeting = ({ genders }) => {
  const i18n = useContext(I18nContext);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Gender') }}>
      <Text>{formatGenders(genders, i18n)}</Text>
    </PropertyRow>
  );
};

GenderTargeting.propTypes = {
  genders: PropTypes.arrayOf(PropTypes.string),
};

GenderTargeting.defaultProps = {
  genders: [],
};
